import { render } from "./personal-center.vue?vue&type=template&id=2fbea44c&scoped=true"
import script from "./personal-center.vue?vue&type=script&lang=js"
export * from "./personal-center.vue?vue&type=script&lang=js"

import "./personal-center.vue?vue&type=style&index=0&id=2fbea44c&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbea44c"]])

export default __exports__